import React, { Component, Fragment } from 'react';
import Popup from 'reactjs-popup';
import { applyPlugin } from 'jspdf-autotable';
import { Container, Row, Col, FormSelect } from 'react-bootstrap';

import jsPDF from 'jspdf';

import powershadesLogo from '../../assets/img/logos/primary/Powershades_Logo_400.png';
import SpinningWheel from '../../Parts/SpinningWheel';
import QuotePricingLockedNew from './QuotePricingLockedNew';
import PlaceOrder from '../OrderModal/PlaceOrder';
import ConfirmApproval from '../../Modals/ConfirmApproval';
import { exportQuote } from '../../ExcelExport/Export';
import { exportOutdoorOrderForm } from '../../OutdoorShadesExport/Export';
import ForceEditModal from '../ForceEditModal';
import QuoteLevelVariables from './QuoteLevelVariables';
import InvoiceStatus from '../InvoiceStatus';
import AdvancedShadeManipulation from './AdvancedShadeManipulation';
import BidSpecControl from './BidSpecControl';
import DemoReview from './DemoReviewComponent';
import PrintQuoteNew from './PrintQuoteNew';
import OrderStatus from './OrderStatus';
import { getQuoteType } from '../QuoteObjectExtensions.ts';
import Button from '../../Parts/Button';
import CorradiOnly from './CorradiOnly';
import ShadeImport from '../ShadeImport';
import ApproveOrderButton from './ApproveOrderButton';

applyPlugin(jsPDF);

class QuoteActions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			duplicateOpen: false,
			duplicateQuoteType: props.newQuote.QuoteType,
			isPsAdmin: false,
			isRepresentative: false,
			isDealer: false,
			isManufacturer: false,
			isDistributor: false,
			isSalesperson: false
		};
	}

	componentDidMount() {
		this.updateRoles();
	}

	componentDidUpdate(prevProps) {
		const { userData } = this.props;
		if (prevProps.userData !== userData) {
			this.updateRoles();
		}
	}

	updateRoles = () => {
		const { userData } = this.props;
		this.setState({ isPsAdmin: userData.roles.some((ur) => ur.role_name === 'powershades_admin') });
		this.setState({ isRepresentative: userData.roles.some((ur) => ur.role_name.includes('rep_')) });
		this.setState({ isDistributor: userData.roles.some((ur) => ur.role_name.includes('distributor')) });
		this.setState({ isDealer: userData.roles.some((ur) => ur.role_name.includes('dealer')) });
		this.setState({ isManufacturer: userData.roles.some((ur) => ur.role_name.includes('manufacturer')) });
		this.setState({ isSalesperson: userData.roles.some((ur) => ur.role_name.includes('salesperson')) });
	};

	render() {
		const {
			editable,
			newQuote,
			quote,
			setShowEditQuoteDisclaimer,
			showEditQuoteDisclaimer,
			setShowConfigurations,
			setEditable,
			editQuote,
			userData,
			ROOT,
			lockAllShades,
			currentDealer,
			demoReviewFailed
		} = this.props;

		const { props } = this;

		const {
			open,
			duplicateLoading = false,
			duplicateOpen,
			duplicateQuoteType,
			isPsAdmin,
			isRepresentative,
			isDistributor,
			isDealer,
			isManufacturer,
			isSalesperson
		} = this.state;

		const adds = [];

		const isOrder = quote.is_order;
		const isPaid = quote.is_paid;
		const hasOutdoorShades = quote.hasOutdoorShades();
		const orderStatusIndex = quote.order_status_index;
		const manufacturerId = quote.manufacturer_id;


		const self = this;
		const quoteType = getQuoteType(newQuote);

		const showPlaceOrder = () => {
			self.setState({ open: true });
		};

		const closePlaceOrder = () => {
			self.setState({ open: false });
		};

		const submit = async () => {
			api.placeOrderPressed(quote.ID).then(() => {
				console.log('placeOrderPressed');
			});

			const hasMissingMsrps = quote.shades.some((sa) => parseFloat(sa.total_msrp) < 1);

			const hasShadeErrors = quote.shades.some((shade) => shade.getErrors().length);

			const hasShadeError = hasMissingMsrps || (hasShadeErrors > 0 && !quote.is_order);

			const hasValidPropertyAddress = quote.property_address !== null
				&& quote.property_address.length !== 0;

			const shadesNeedingUnlocked = quote.shades.filter((s) => s.needsRepricing());

			const quoteAccessoriesNeedingUnlocked = quote.accessories.filter((a) =>
				newQuote.Data.isAccessoryOld(a.part_number));

			const isRMAAndHasNoPreviousQuoteId = (newQuote.IsRework || newQuote.IsRMA)
				&& quote.shades.length > 0
				&& !quote.previousQuoteId > 0;

			if (hasShadeError) {
				ROOT.alert({
					text: 'Please click Edit Quote and address all shade errors before placing an order.',
					title: 'Shade Errors',
					quoteType,
					icon: 'error',
					oneButton: true,
				})
					.then(() => { })
					.catch(() => { });
			} else if (!hasValidPropertyAddress) {
				ROOT.alert({
					text: 'Please enter a valid property address before placing an order.',
					title: 'Missing Property Address',
					quoteType,
					icon: 'error',
					oneButton: true,
				})
					.then(() => { })
					.catch(() => { });
			} else if (newQuote.needsVerification()) {
				ROOT.alert({
					text: 'Please verify the quote configuration.',
					title: 'Quote Configuration Verification',
					noCancelButton: false,
					cancelButtonText: 'Cancel',
					acceptButtonText: 'Show Configuration',
					quoteType,
					icon: 'warning',
					onAccept: () => {
						if (!editable) {
							setShowEditQuoteDisclaimer({
								action: () => {
									setShowConfigurations(true);
								},
							});
						} else {
							setShowConfigurations(true);
						}
					},
				})
					.then(() => { })
					.catch(() => { });
			} else if (
				shadesNeedingUnlocked.length > 0
				|| quoteAccessoriesNeedingUnlocked.length > 0
			) {
				const repriceOldItems = () => {
					quoteAccessoriesNeedingUnlocked.forEach((a) => {
						newQuote.Data.setAccessoryQuantity(a.line_number, a.quantity);
					});

					newQuote.unlock();
					setEditable(true);

					shadesNeedingUnlocked.forEach((s) => {
						s.unlock();
					});
					newQuote.Data.RePriceWholeQuote();
				};
				ROOT.alert({
					text: 'This quote has expired. Quotes are valid for 90 days. To place this order, please reprice these shades/accessories via the button below.',
					title: 'Old Shade Pricing',
					icon: 'warning',
					cancelButtonText: 'Cancel',
					acceptButtonText: 'Reprice Shades',
					onAccept: repriceOldItems,
				})
					.then(() => { })
					.catch(() => { });
			} else if (quote.getFabricSamplesQuantity() > 10) {
				ROOT.alert({
					text: 'Please limit fabric samples order quantity to 10 or less.',
					title: 'Fabric Samples Limit',
					quickFormat: 'error',
				})
					.then(() => { })
					.catch(() => { });
			} else if (isRMAAndHasNoPreviousQuoteId) {
				ROOT.alert({
					text: 'Please enter the previous quote id (The PS#) in Advanced Settings to place this RMA/Rework',
					title: 'No Previous Quote Id',
					quickFormat: 'error',
				})
					.then(() => { })
					.catch(() => { });
			} else {
				const propertyName = quote.property_address.company_name;

				const addressSnapshot = (
					await api.getQuoteAddressSnapshot(propertyName, quote.dealer_id)
				).data.address_snapshot;

				if (addressSnapshot !== null) {
					ROOT.alert({
						title: 'Existing Property Name',
						icon: 'warning',
						text: isDealer ? (
							<span>
								There is already an installation address with the property name &quot;
								{propertyName}
								&quot;.
								<br />
								<br />
								Continuing with this property name will add shades to the existing
								property in the dashboard.
								<span style={{
									display: 'block', marginBottom: '10px'
								}}
								/>
							</span>
						) : (
							<span>
								There is already an installation address with the property name &quot;
								{propertyName}
								&quot; for this dealer.
								<br />
								<br />
								Continuing with this property name will add shades to the existing
								property in the dashboard.
								<span style={{
									display: 'block', marginBottom: '10px'
								}}
								/>
							</span>
						),
						cancelButtonText: 'Edit Property Name',
						acceptButtonText: 'Continue',
					})
						.then(showPlaceOrder)
						.catch(() => { });
				} else {
					const isBlank = (str) => (!str || /^\s*$/.test(str));

					if (isBlank(newQuote.QuoteSubstitution.notes)) {
						showPlaceOrder();
					} else {
						ROOT.alert({
							title: 'Place an Order',
							icon: 'warning',
							text: 'Please acknowledge any notes that specify amendments to this order may be subject to price adjustment. We will do our best to accommodate all requests that promote our standard of quality.',
							cancelButtonText: 'Cancel',
							acceptButtonText: 'I understand, thanks!',
						})
							.then(showPlaceOrder)
							.catch(() => { });
					}
				}
			}
		};

		const buttonAdds = `btn-${quoteType}`;

		const placeOrderButton = (
			<Col key="placeOrder" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<Button
					fullWidth
					color={quoteType ?? 'green'}
					title="Place Order"
					onClick={submit}
				>
					Place Order
				</Button>
			</Col>
		);

		if (!isSalesperson) {
			adds.push(
				<Popup open={open} key="placeOrderP" keyX="placeOrderP" onClose={closePlaceOrder}>
					<PlaceOrder
						quoteType={quoteType}
						key="place-order-component"
						ROOT={ROOT}
						isPsAdmin={isPsAdmin}
						isRep={isRepresentative}
						isDistributor={isDistributor}
						territoryId={quote.territory_id}
						quote={quote}
						newQuote={newQuote}
						close={() => {
							closePlaceOrder();
						}}
						done={ROOT.refreshContent}
						submit={submit}
						dealers={props.dealers}
						territories={props.territories}
						currentDealer={currentDealer}
					/>
				</Popup>
			);
		}

		if (!isOrder && !newQuote.IsDemo && !isSalesperson) {
			adds.push(placeOrderButton);
		} else if (newQuote.IsDemo) {
			adds.push(
				<Col key="demo-review" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					<DemoReview
						quoteType={quoteType}
						demoReviewFailed={demoReviewFailed}
						newQuote={newQuote}
						isPsAdmin={isPsAdmin}
						placeOrderButton={placeOrderButton}
						isOrder={isOrder}
					/>
				</Col>
			);
		}

		const territoryId = quote.territory_id;

		if (isOrder && orderStatusIndex < 2 && isPsAdmin) {
			adds.push(
				<ApproveOrderButton
					quoteType={quoteType}
					key="approve-order"
					quoteId={quote.ID}
				/>
			);
		}

		adds.push(
			<Col key="export-to-excel" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<Button
					title="Export Quote to Excel"
					color={quoteType ?? 'green'}
					fluid
					fullWidth
					onClick={() => exportQuote(quote, userData, newQuote)}
				>
					Export Quote
				</Button>
			</Col>
		);

		if (isPsAdmin && hasOutdoorShades) {
			adds.push(
				<Col key="export-outdoor" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					<Button
						title="Export Outdoor Shades"
						color={quoteType ?? 'green'}
						fluid
						fullWidth
						onClick={() => {
							exportOutdoorOrderForm(quote);
						}}
					>
						Export Outdoor Shades
					</Button>
				</Col>
			);
		}
		adds.push(
			<Col xl="auto" key="print-quote-new-button" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<PrintQuoteNew
					color={buttonAdds}
					newQuote={newQuote}
					territories={props.territories}
					territory_id={territoryId}
				/>
			</Col>
		);

		const duplicateFunction = () => {
			if (isPsAdmin) {
				this.setState({ duplicateOpen: true });
			} else {
				this.setState({ duplicateLoading: true });
				api.duplicateQuote(
					quote.ID,
					self.state.duplicateQuoteType,
					newQuote.Data.motors
				).then(() => ROOT.loadContent('#Home'));
			}
		};

		if (!isManufacturer) {
			adds.push(
				<Fragment key="duplicate-quote-fragment">
					<Popup
						className="mobile-modal"
						key="duplicatequote-modal"
						open={duplicateOpen}
						closeOnDocumentClick={false}
						onClose={() => {
							this.setState({ duplicateOpen: false });
						}}
						contentStyle={{
							minHeight: '30vh',
							overflowX: 'hidden',
						}}
					>
						<Container style={{ minHeight: '30vh' }} className="local-bootstrap">
							<Row className="mb-4">
								<Col>
									<h4 className={`text-${quoteType}`}>Select Quote Type</h4>
								</Col>
							</Row>
							<Row>
								<Col>
									<FormSelect
										value={duplicateQuoteType}
										onChange={(e) => {
											self.setState({ duplicateQuoteType: e.target.value });
										}}
									>
										{this.props.quoteTypes.length > 0 ? (
											this.props.quoteTypes.map((qt) => (
												<option key={qt.name} value={qt.name}>
													{qt.name}
												</option>
											))
										) : (
											<option key="loading" value="loading">
												Loading...
											</option>
										)}
									</FormSelect>
								</Col>
							</Row>
							<Row className="bottom-row">
								<Col className="text-start mb-2">
									<Button
										color="grey"
										onClick={() => {
											this.setState({ duplicateOpen: false });
										}}
									>
										Close
									</Button>
								</Col>
								{!duplicateLoading ? (
									<Col className="text-end mb-2">
										<Button
											color={quoteType ?? 'green'}
											disabled={duplicateLoading}
											onClick={() => {
												this.setState({ duplicateLoading: true });
												api.duplicateQuote(
													quote.ID,
													duplicateQuoteType,
													newQuote.Data.motors
												).then(() => ROOT.loadContent('#Home'));
											}}
										>
											Duplicate
										</Button>
									</Col>
								) : (
									<Col className="mb-2 text-center">
										<SpinningWheel
											style={{ fontSize: '2em' }}
											className={`text-${quoteType}`}
										/>
									</Col>
								)}
							</Row>
						</Container>
					</Popup>
					<Col xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
						<Button
							fullWidth
							disabled={duplicateLoading}
							color={quoteType ?? 'green'}
							title="Duplicate the Current Quote"
							onClick={duplicateFunction}
						>
							{!duplicateLoading ? (
								'Duplicate Quote'
							) : (
								<SpinningWheel
									style={{
										fontSize: '1.5em',
										marginTop: '0.25em',
										marginBottom: '-0.5em',
									}}
									className={`text-${quoteType}`}
								/>
							)}
						</Button>
					</Col>
				</Fragment>
			);
		}

		// if (isPsAdmin && !isPaid) {
		//     //Mark as Paid
		//     adds.push(
		//         <ButtonFunction
		//             title={'Mark Quote as Paid'}
		//             key={'mark-paid'}
		//             keyX={'mark-paid'}
		//             className={`green-button ${buttonAdds}`}
		//             action={() => {

		//                 if (!confirm('Are you sure you want to mark this order as paid?')) return;

		//                 api.markAsPaid(quote.ID)
		//                     .then(() => ROOT.refreshContent());
		//             }}
		//             buttonLabel={"Mark Paid"}
		//         ></ButtonFunction>
		//     )
		// }

		if (
			isOrder
			&& orderStatusIndex < 2
			&& !isPaid
			&& (isDistributor || isRepresentative || isPsAdmin)
		) {
			adds.push(
				<Col key="require-payment" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					<Button
						color={quoteType ?? 'green'}
						title="Mark order as requiring payment"
						onClick={() => {
							if (
								// TODO: Replace this with root.alert
								!confirm(
									'Are you sure you want to decline credit and require payment for this order?'
								)
							) { return; }

							api.markRequirePayment(quote.ID).then(() => ROOT.refreshContent());
						}}
					>
						Require Payment
					</Button>
				</Col>
			);
		}

		if (isPsAdmin && !editable && isOrder && manufacturerId <= 0) {
			adds.push(
				<Popup
					key="forceEdit"
					keyX="forceEdit"
					trigger={(open) => (
						<Col xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
							<Button
								key="forceEdit"
								color={quoteType ?? 'green'}
								title="Force Unlock Order"
								onClick={open}
							>
								Force Edit
							</Button>
						</Col>
					)}
				>
					{(close) => (
						<ForceEditModal
							key="force-edit-modal"
							setEditable={() => {
								newQuote.unlock(() => {
									setEditable(true);
								});
							}}
							quote={quote}
							close={close}
						/>
					)}
				</Popup>
			);
		}

		adds.push(
			<Col key="installer-copy" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<Button
					fullWidth
					title="Download the Installer Copy"
					color={quoteType ?? 'green'}
					// TODO: Define this function before using it
					onClick={() => downloadInstallerCopy(quote, userData)}
				>
					Installer Copy
				</Button>
			</Col>
		);

		if (isOrder && isPsAdmin) {
			adds.push(
				<Popup
					key="invoiceStatus"
					keyX="invoiceStatus"
					modal
					trigger={
						(
							<Col xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
								<Button
									color={quoteType ?? 'green'}
									title="Check Invoice Status"
									onClick={open}
								>
									Invoice Status
								</Button>
							</Col>
						)
					}
				>
					{(close) => (
						<InvoiceStatus
							alert={ROOT.alert}
							isPsAdmin={isPsAdmin}
							quoteId={newQuote.Id}
							close={close}
						/>
					)}
				</Popup>
			);
		}

		// if (isOrder) {
		// 	adds.push(
		// 		<Col key="order-status" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
		// 			<OrderStatus quoteType={quoteType} key={quote.ID} quoteId={quote.ID} />
		// 		</Col>
		// 	);
		// }

		if (
			!editable
			&& !isOrder
			&& (isPsAdmin || newQuote.IsCedia || newQuote.IsDemo)
		) {
			adds.push(
				<Col key="unlock-quote" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					<QuotePricingLockedNew
						keyX="unlock-quote"
						setEditable={setEditable}
						unlockQuote={editQuote}
						showEditQuoteDisclaimer={showEditQuoteDisclaimer}
						setShowEditQuoteDisclaimer={setShowEditQuoteDisclaimer}
						lockAllShades={lockAllShades}
						unlockShade={newQuote.Data.unlockShade}
						variant={quoteType}
						newQuote={newQuote}
					/>
				</Col>
			);
		}

		if (
			!editable
			&& (!isOrder || (isOrder && manufacturerId <= 0))
			&& isPsAdmin
			&& newQuote.IsExternal
		) {
			adds.push(
				<Col key="secret-edit-o.o" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					<Button
						color={quoteType ?? 'green'}
						onClick={() => {
							editQuote((quote) => {
								// TODO: Change this close() to a non-restricted global
								close();
								setEditable(true);
								quote.noPricing = true;
							});
						}}
					>
						No Pricing Edit
					</Button>
				</Col>
			);
		}

		adds.push(
			<Col key="quote-variables" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<QuoteLevelVariables
					keyX="quote-variables"
					setEditable={setEditable}
					unlockQuote={editQuote}
					onChange={newQuote.Data.QuoteFieldChange}
					newQuote={newQuote}
					isPsAdmin={isPsAdmin}
					isRepresentative={isRepresentative}
				/>
			</Col>
		);

		adds.push(
			<Col key="advancedshademanipulation" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<AdvancedShadeManipulation newQuote={newQuote} />
			</Col>
		);

		if (newQuote.IsBidSpec) {
			adds.push(
				<Col key="bidspec-control" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					<BidSpecControl
						quoteColor={newQuote.QuoteColor}
						shadeAssemblies={newQuote.QuoteSubstitution.shades}
						setShadeLabor={newQuote.Data.setShadeLabor}
						setShadeOverhead={newQuote.Data.setShadeOverhead}
						setShadeMarkup={newQuote.Data.setShadeMarkup}
					/>
				</Col>
			);
		}

		if (newQuote.IsDemo) {
			adds.push(<span key="isDemo" />);
		}

		if (newQuote.Data.shadeAssemblies.Items.some((s) => s.indoor_outdoor == 'outdoor')
			&& !newQuote.Data.shadeAssemblies.Items.some((s) => s.indoor_outdoor == 'indoor')
			&& isOrder
			&& orderStatusIndex < 5
			&& isPsAdmin) {
			adds.push(
				<Col key="outdoor-only" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
					< CorradiOnly QuoteId={quote.ID} />
				</Col>
			);
		}

		if (isPsAdmin && !isOrder) {
			adds.push(
				<Col key="shade-import">
					<ShadeImport 
						quoteType={quoteType}
						quoteId={newQuote.Id}
					/>
				</Col>
			);
		}

		return (
			<Container
				className="local-bootstrap mb-2 p-0"
				fluid
			// style={{
			// 	marginRight: '1em', marginLeft: '1em', marginBottom: '1em'
			// }}
			>
				<Row className="justify-content-end" style={{ paddingLeft: "0.5em", paddingRight: "0.5em" }}>
					<Col xl="auto" lg={12}>
						<Row>{adds.reverse()}</Row>
					</Col>
				</Row>
			</Container>
		);
	}
}

export default QuoteActions;

async function downloadInstallerCopy(quote, user) {
	// initialize jsPDF
	const doc = new jsPDF(); // eslint-disable-line new-cap

	doc.setFontSize(10);

	// doc.setFontStyle = function () {};

	doc.text('Installer Report', 15, 10);

	const dealerId = quote.dealer_id;

	let dealer = null;

	if (dealerId > 0) {
		dealer = (await api.getDealerMeta(dealerId))?.data?.dealer ?? false;
	}

	const logoImage = new Image();
	logoImage.src = powershadesLogo;

	if (dealer) {
		// TODO: Define getName before use
		let identityHeader = getName(quote, user, dealer);
		// TODO: Define addInformation before use
		identityHeader += addInformation(quote, user, dealer);
		doc.text(identityHeader, 15, 25);
	}

	const headStyles = { fillColor: '#8DC73E' };

	doc.autoTable({
		columns: [{
			dataKey: 'id', header: 'Sold To'
		}],
		body: [['']],
		startY: 20,
		showHead: 'firstPage',
		margin: { left: 107 },
		styles: { overflow: 'hidden' },
		headStyles,
	});
	doc.autoTable({
		columns: [{
			dataKey: 'id', header: 'Install Location'
		}],
		body: [['']],
		startY: doc.lastAutoTable.finalY,
		showHead: 'firstPage',
		margin: { left: 107 },
		styles: { overflow: 'hidden' },
		headStyles,
	});

	// Shades Table
	let tableColumn = [
		['Name', 'Room', 'Type', 'Motorized', 'Mount', 'Width', 'Height', 'Product'],
	];
	let tableRows = [];

	const { shades } = quote;
	// const columnStyles = {
	// 	0: { cellWidth: 100 },
	// 	1: { cellWidth: 80 },
	// 	2: { cellWidth: 80 },
	// 	// etc
	// };

	doc.autoTable({
		columns: [
			{ header: 'Date' },
			{ header: 'Quote Title' },
			{ header: 'Reference Number' },
			{ header: 'Quote Number' },
			{ header: 'Salesperson' },
		],
		body: [
			[
				// TODO: Define getCurrentDateString before use
				[getCurrentDateString()],
				[quote.title],
				[quote.reference_number],
				[`PS${quote.ID}`],
				[''],
			],
		],
		startY: doc.lastAutoTable.finalY + 20,
		showHead: 'firstPage',
		styles: { overflow: 'hidden' },
		headStyles,
		pageBreak: 'avoid',
	});

	if (shades.length > 0) {
		const indoorShades = shades.filter(
			(s) => s.options().find((s) => s.varName === 'indoor_outdoor').value === 'indoor'
		);
		const outdoorShades = shades.filter(
			(s) => s.options().find((s) => s.varName === 'indoor_outdoor').value === 'outdoor'
		);
		// for each ticket pass all its data into an array
		if (indoorShades) {
			indoorShades.forEach((shade) => {
				let productInfo = shade.options().find((s) => s.varName === 'header_type').value;
				productInfo += `-${shade.options().find((s) => s.varName === 'fabric_name').value}`;
				const fabric2 = shade.options().find((s) => s.varName === 'fabric2_name');
				if (fabric2 && fabric2.value) {
					productInfo += `-${fabric2}`;
				}
				const isCoupledShade = shade.options().find((s) => s.varName === 'coupledShades').conditional(shade) ?? false;
				const shadeTotalWidth = shade.data().total_width;
				
				const shadeActualWidth = isCoupledShade ? shadeTotalWidth : shade.options().find((s) => s.varName === "width").value;

				const shadeData = [
					shade.options().find((s) => s.varName === 'shade_name').value,
					shade.options().find((s) => s.varName === 'room_name').value,
					shade.options().find((s) => s.varName === 'single_dual').value,
					shade.isMotorized() ? 'Y' : 'N',
					shade.options().find((s) => s.varName === 'mount_type').value,
					shadeActualWidth,
					shade.options().find((s) => s.varName === 'height').value,
					productInfo,
				];
				// push each ticket's info into a row
				tableRows.push(shadeData);
			});
			if (tableRows.length > 0) {
				doc.autoTable({
					head: [['Indoor Shades']],
					body: [],
					startY: doc.lastAutoTable.finalY + 20,
					headStyles,
					didDrawPage: (data) => {
						// ! Do not change these variables to const or let. It'll break. :(
						// Header
						doc.setFontSize(20);
						doc.setTextColor(40);

						var pageSize = doc.internal.pageSize; // eslint-disable-line
						var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight(); // eslint-disable-line

						if (logoImage) {
							doc.addImage(
								logoImage,
								'JPEG',
								(data.settings.margin.left + data.settings.margin.right) / 2
								+ 20
								+ 50,
								pageHeight - 25,
								35,
								18
							);
						}

						// Footer
						var str = 'Page ' + doc.internal.getNumberOfPages(); // eslint-disable-line
						// Total page number plugin only available in jspdf v1.0+
						if (typeof doc.putTotalPages === 'function') {
							str = str + ' of ' + totalPagesExp; // eslint-disable-line
						}
						doc.setFontSize(10);

						// jsPDF 1.4+ uses getWidth, <1.4 uses .width
						var pageSize = doc.internal.pageSize; // eslint-disable-line
						var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight(); // eslint-disable-line
					},
				});
			}
		}
		if (outdoorShades) {
			doc.autoTable({
				head: tableColumn,
				body: tableRows,
				startY: doc.lastAutoTable.finalY,
				headStyles,
			});

			tableRows = [];

			outdoorShades.forEach((shade) => {
				let productInfo = shade.options().find((s) => s.varName === 'header_type').value;
				productInfo += `-${shade.options().find((s) => s.varName === 'fabric_name').value}`;
				const fabric2 = shade.options().find((s) => s.varName === 'fabric2_name');
				if (fabric2 && fabric2.value) {
					productInfo += `-${fabric2}`;
				}
				const shadeData = [
					shade.options().find((s) => s.varName === 'shade_name').value,
					shade.options().find((s) => s.varName === 'room_name').value,
					shade.options().find((s) => s.varName === 'single_dual').value,
					shade.options().find((s) => s.varName === 'mount_type').value,
					shade.options().find((s) => s.varName === 'width').value,
					shade.options().find((s) => s.varName === 'height').value,
					productInfo,
				];
				// push each ticket's info into a row
				tableRows.push(shadeData);
			});

			tableColumn = [['Name', 'Room', 'Type', 'Mount', 'Width', 'Height', 'Product']];
			if (tableRows.length > 0) {
				doc.autoTable({
					head: [['Outdoor Shades']],
					body: [],
					startY: doc.lastAutoTable.finalY + 20,
					headStyles,
				});
				doc.autoTable({
					head: tableColumn,
					body: tableRows,
					startY: doc.lastAutoTable.finalY,
					headStyles,
				});
			}
			tableRows = [];
			tableColumn = [['Id', 'Quantity', 'Name', 'Description']];
		}
	}

	// page break for accessories
	doc.setPage(doc.lastAutoTable.pageNumber + 1);

	const accessories = quote.accessories.filter((acc) => acc.quantity !== 0);

	if (accessories) {
		accessories.forEach((acc) => {
			const accessoryData = [acc.id, acc.quantity, acc.name, acc.description];
			// push each ticket's info into a row
			tableRows.push(accessoryData);
		});
		if (tableRows.length !== 0) {
			doc.autoTable({
				head: [['Accessories']], body: [], headStyles
			});
			doc.autoTable({
				head: tableColumn,
				body: tableRows,
				startY: doc.lastAutoTable.finalY,
				pageBreak: 'avoid',
				headStyles,
			});
		}
	}

	const totalPagesExp = '{total_pages_count_string}';

	doc.autoTable({
		columns: [{ header: 'Notes' }],
		body: [[''], ['']],
		startY: doc.lastAutoTable.finalY + 20,
		showHead: 'firstPage',
		styles: { overflow: 'hidden' },
		headStyles,
		pageBreak: 'avoid',
	});

	doc.autoTable({
		columns: [{ header: 'Installed By' }],
		body: [['']],
		startY: doc.lastAutoTable.finalY,
		showHead: 'firstPage',
		margin: { right: 107 },
		styles: { overflow: 'hidden' },
		headStyles
	});
	doc.autoTable({
		columns: [{ header: 'Approved By' }],
		body: [['']],
		startY: doc.lastAutoTable.finalY,
		showHead: 'firstPage',
		margin: { right: 107 },
		styles: { overflow: 'hidden' },
		headStyles,
		didDrawPage: () => {
			// ! Do not change these variables to const or let. It'll break. :(
			// Header
			doc.setFontSize(20);
			doc.setTextColor(40);

			var pageSize = doc.internal.pageSize; // eslint-disable-line
			var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight(); // eslint-disable-line

			// Footer
			var str = 'Page ' + doc.internal.getNumberOfPages(); // eslint-disable-line
			// Total page number plugin only available in jspdf v1.0+
			if (typeof doc.putTotalPages === 'function') {
				str = str + ' of ' + totalPagesExp; // eslint-disable-line
			}
			doc.setFontSize(10);

			// jsPDF 1.4+ uses getWidth, <1.4 uses .width
			var pageSize = doc.internal.pageSize; // eslint-disable-line
			var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight(); // eslint-disable-line
		},
	});

	doc.save(`PS${quote.ID} InstallerReport.pdf`);
}

function getCurrentDateString() {
	let today = new Date();
	const dd = String(today.getDate()).padStart(2, '0');
	const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
	const yyyy = today.getFullYear();

	today = `${mm}/${dd}/${yyyy}`;
	return today;
}

function getName(quote, user, dealer) {
	return dealer.name;
}

function addInformation(quote, user, dealer) {
	let baseInfo = '';
	if (dealer.address) {
		baseInfo = `\n${dealer.address}`;
		baseInfo += `\n${dealer.city}, ${dealer.state} ${dealer.zip}`;
		baseInfo += `\nPhone: ${dealer.phone}`;
		baseInfo += `\nEmail: ${dealer.email}`;
	}
	return baseInfo;
}
